import React from "react";
import styles from "./Loader.module.scss";

const Loader = ({
  fullScreen = false,
  size = "24px",
  color = "#4f46e5",
  trackColor = "rgba(0, 0, 0, 0.1)",
  className = "",
}) => {
  const spinner = (
    <div
      className={`${styles.spinner} ${className}`}
      style={{
        width: size,
        height: size,
        borderColor: trackColor,
        borderTopColor: color,
        borderWidth: "3px",
        borderStyle: "solid",
      }}
    />
  );

  if (fullScreen) {
    return <div className={styles.fullScreenOverlay}>{spinner}</div>;
  }

  return spinner;
};

export default Loader;
